export class PageAuditGroupModel {
    constructor(dateString, pageAudits) {
        this.date = new Date(dateString);
        this.dateString = dateString;
        this.pageAudits = pageAudits;
    }
}